// extracted by mini-css-extract-plugin
export default {"cardOffer":"AddProduct_cardOffer__XmGKm","btnOffer":"AddProduct_btnOffer__IlO-0"};